import api from '@/model/login'

const state = {
  marketList: []
}

const getters = {
  marketList: (state) => state.marketList
}

const mutations = {
  SET_MARKETS(state, data) {
    state.marketList = data
  }
}

const actions = {
  async getMarkets({ commit }) {
    try {
      const data = await api.getMarketList()
      commit('SET_MARKETS', data || [])
    } catch (error) {
      console.log(error)
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
